// extracted by mini-css-extract-plugin
export default {"text":"TextTooltip_text__3vhQU"};